import {FormattedDate} from 'react-intl';

import {createElement, PropTypes} from 'rlink-react';
import {mergeStaticOptions} from 'rlink-utils/object';

import DateInput from './DateInput';

export default class DateTimeInput extends DateInput {
  get hourFormat () {
    return this.fromPropsOrContext('hourFormat');
  }

  get minuteFormat () {
    return this.fromPropsOrContext('minuteFormat');
  }

  get hour () {
    if (this.hasValue(this.value)) {
      return this.value.getHours();
    } else {
      return this.state.hour;
    }
  }

  get minute () {
    if (this.hasValue(this.value)) {
      return this.value.getMinutes();
    } else {
      return this.state.minute;
    }
  }

  get hours () {
    let hours = [];
    for (let i = 0; i <= 23; i++) {
      let date = new Date(0, 0, 0, i);
      hours.push(<FormattedDate
        key={i}
        value={date}
        hour={this.hourFormat}>
        {formattedDate => <option value={i}>
          {formattedDate}
        </option>}
      </FormattedDate>);
    }
    return hours;
  }

  get minutes () {
    let minutes = [];
    for (let i = 0; i <= 59; i++) {
      let date = new Date(0, 0, 0, 0, i);
      minutes.push(<FormattedDate
        key={i}
        value={date}
        minute={this.minuteFormat}>
        {formattedDate => <option value={i}>
          {formattedDate}
        </option>}
      </FormattedDate>);
    }

    return minutes;
  }

  getDateStruct () {
    return {
      day: this.day,
      month: this.month,
      year: this.year,
      hour: this.hour,
      minute: this.minute,
    };
  }

  constructUTCDate (dateStruct) {
    return new Date(Date.UTC(dateStruct.year, dateStruct.month, dateStruct.day, dateStruct.hour, dateStruct.minute));
  }

  constructLocalDate (dateStruct) {
    return new Date(dateStruct.year, dateStruct.month, dateStruct.day, dateStruct.hour, dateStruct.minute);
  }

  renderTimeSelector () {
    return (<div>
      <select
        value={this.hour}
        key="hour"
        onChange={ev => this.updateDate(ev, 'hour')}
        name="hours">
        {this.hours}
      </select>
      <span key="divider">:</span>
      <select
        value={this.minute}
        key="minute"
        onChange={ev => this.updateDate(ev, 'minute')}
        name="minutes">
        {this.minutes}
      </select>
    </div>);
  }

  renderSelectors () {
    return [this.renderDateSelector(), this.renderTimeSelector()];
  }
}

mergeStaticOptions(DateTimeInput, {
  propTypes: {
    hourFormat: PropTypes.oneOf([
      'numeric',
      '2-digit',
    ]),
    minuteFormat: PropTypes.oneOf([
      'numeric',
      '2-digit',
    ]),
  },
  defaultProps: {
    hourFormat: 'numeric',
    minuteFormat: 'numeric',
  },
});



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/DateTimeInput.jsx